<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        <PatientsCounter
          queueTitle="Atendimentos"
          queueType="reception"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <authorization permissionKey="receptionist_queue" can="read">
          <Attendances queueType="reception" :poolInterval="60000" />
        </authorization>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Attendances from "@/components/queues/attendances.vue";
import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";

export default {
  name: "receptionist",
  components: {
    Attendances,
    PatientsCounter,
  },
};
</script>

<style lang="sass" scoped></style>
